import React from 'react';
import numeral from 'numeral';
import { SmallText, BodyText } from '../../typography';
import Mark from '../../ui/mark';
import dlt from '../../../utils/default-lang';
import { FormattedMessage } from 'react-intl';
import Moment from 'react-moment';
import Checkbox from '../../ui/plain-checkbox';
import { TotalValueText, SaleTableItemSC } from './automatic-sale-modal.styled';

const SaleTableItem = ({
  date,
  amount,
  status,
  name,
  originalValue,
  restValue,
  isTablet,
  hasPagination,
  onDetailClick,
  inArrear,
  lastPaymentDate,
  onClick,
  checked,
  payments,
  paymentsTotal,
}) => {
  return (
    <SaleTableItemSC
      hasPagination={hasPagination}
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      {isTablet ? (
        <>
          <td>
            <Checkbox checked={checked} />
          </td>
          <td>{name}</td>
        </>
      ) : (
        <>
          <td>
            <Checkbox checked={checked} />
          </td>
          <td>{name}</td>
          <td>
            <TotalValueText>
              {numeral(originalValue).format('0,00.00')} € {' / '}
            </TotalValueText>
            <BodyText>{numeral(restValue).format('0,00.00')} €</BodyText>
          </td>
        </>
      )}

      {isTablet ? null : (
        <td>
          <BodyText>
            {payments} / {paymentsTotal}
          </BodyText>
        </td>
      )}

      {isTablet ? (
        <td>
          <SmallText className="black-transparent">
            <Moment parse="DD.MM.YYYY" format="DD. MMMM YYYY">
              {date}
            </Moment>
          </SmallText>
          <SmallText className="bolder">
            <Mark colorStyle={status === 'late' ? 'ORANGE' : 'GREEN'}>
              {status === 'sale' ? (
                <FormattedMessage id="global_sold" defaultMessage={dlt['global_sold']} />
              ) : status === 'late' ? (
                <FormattedMessage id="global_late" defaultMessage={dlt['global_late']} />
              ) : (
                <FormattedMessage id="global_paid" defaultMessage={dlt['global_paid']} />
              )}
            </Mark>
          </SmallText>
        </td>
      ) : (
        <>
          <td>
            <BodyText>
              <Moment parse="DD.MM.YYYY" format="DD. MMMM YYYY">
                {date}
              </Moment>
            </BodyText>
          </td>
          <td>
            <SmallText className="bolder">
              <Mark colorStyle={status === 'late' ? 'ORANGE' : 'GREEN'}>
                {status === 'sale' ? (
                  <FormattedMessage id="global_sold" defaultMessage={dlt['global_sold']} />
                ) : status === 'late' ? (
                  <>
                    <FormattedMessage id="global_late" defaultMessage={dlt['global_late']} />{' '}
                    {inArrear}{' '}
                    {inArrear === 1 ? (
                      <FormattedMessage id="global_day" defaultMessage={dlt['global_day']} />
                    ) : inArrear > 1 && inArrear <= 4 ? (
                      <FormattedMessage
                        id="global_more_days"
                        defaultMessage={dlt['global_more_days']}
                      />
                    ) : (
                      <FormattedMessage id="global_days" defaultMessage={dlt['global_days']} />
                    )}
                  </>
                ) : (
                  // <FormattedMessage id="global_paid" defaultMessage={dlt['global_paid']} />
                  <FormattedMessage id="global_paying" defaultMessage={dlt['global_paying']} />
                )}
              </Mark>
            </SmallText>
          </td>
        </>
      )}
    </SaleTableItemSC>
  );
};

export default SaleTableItem;
